import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './index.module.scss';
import aiteImg from '../../assets/images/aite.png';
import mimaImg from '../../assets/images/mima.png';
import userImg from '../../assets/images/user.png';
import cancelImg from '../../assets/images/cancel.png';
import yanzhengmaƒImg from '../../assets/images/yanzhengma.png';
import * as R from 'ramda';
import { sendCode, register, login, googleLoginApi } from '../../services';
import { useSelector, useDispatch } from 'react-redux';
import { GoogleLogin } from '@react-oauth/google';
import { message, Button } from 'antd';
import { useHistory, useLocation } from 'react-router-dom';
const COUNT_DOWN_S = 120;
const COUNT_DOWN_START_MS_KEY = 'count_down_start_ms';

export const Login = () => {
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const showLogin = useSelector((state) => state.global.showLogin);
  const tabs = [
    {
      v: 'login',
      l: t('login.login'),
    },
    {
      v: 'sign_up',
      l: t('login.signUp'),
    },
  ];
  const [tabActive, setTabActive] = useState(0);
  const [loading, setLoading] = useState(false);
  const [sendText, setSendText] = useState(t('login.send'));
  const [isCountdownActive, setIsCountdownActive] = useState(false);
  const [form, setform] = useState({
    email: '',
    password: '',
    name: '',
    verification_code: '',
    agreement: true,
  });

  // Update sendText when language changes
  useEffect(() => {
    if (!isCountdownActive) {
      setSendText(t('login.send'));
    }
  }, [t, isCountdownActive]);

  useEffect(() => {
    if (showLogin) {
      const params = new URLSearchParams(location.search);

      if (params.has('event')) {
        params.delete('event');
        const newSearch = params.toString();
        const newPath = `${location.pathname}${newSearch ? '?' + newSearch : ''}`;
        history.replace(newPath);
      }
    }
  }, [showLogin]);

  useEffect(() => {
    const historyCountDown = localStorage.getItem(COUNT_DOWN_START_MS_KEY);
    if (historyCountDown) {
      const historyCountDownDiff = parseInt((new Date().getTime() - historyCountDown) / 1000);
      if (historyCountDownDiff < COUNT_DOWN_S) {
        countDown(COUNT_DOWN_S - historyCountDownDiff);
      } else {
        localStorage.removeItem(COUNT_DOWN_START_MS_KEY);
      }
    }
  }, []);

  const changeInput = (value, key) => {
    setform((oldV) => {
      return R.assocPath([key], value, oldV);
    });
  };

  const send = async () => {
    try {
      const { email, password, name } = form;
      if (!(vEmail() && password && name)) {
        return message.error(t('login.enterCorrectInfo'));
      } else if (isCountdownActive) {
        return false;
      }
      await sendCode({ email, password, name });
      countDown();
      message.success(t('login.sendSuccess'));
      localStorage.setItem(COUNT_DOWN_START_MS_KEY, new Date().getTime());
    } catch (error) {
      message.error(error.message || t('login.sendFailed'));
    }
  };

  const countDown = (s = COUNT_DOWN_S) => {
    let count_down = s;
    setIsCountdownActive(true);
    const timer = setInterval(function () {
      count_down -= 1;
      if (count_down > 0) {
        setSendText(count_down + 's');
      } else {
        setSendText(t('login.send'));
        setIsCountdownActive(false);
        clearInterval(timer);
      }
    }, 1000);
  };

  const submit = async () => {
    if (tabActive === 0) {
      loginFunc();
    } else {
      registerFunc();
    }
  };

  const showLoginPopup = (value = false) => {
    dispatch({
      type: 'global/setShowLogin',
      payload: value,
    });
  };

  const forgotPassword = () => {
    showLoginPopup(false);
    dispatch({
      type: 'global/setShowUpdatePassword',
      payload: true,
    });
  };

  const loginFunc = async () => {
    try {
      const { email, password, agreement } = form;
      if (!vEmail()) {
        return message.error(t('login.invalidEmail'));
      } else if (!password) {
        return message.error(t('login.passwordRequired'));
      } else if (!agreement) {
        return message.error(t('login.agreementRequired'));
      }
      setLoading(true);
      const res = await login({ email, password });
      message.success(res.data.message);
      localStorage.setItem('session_id', res.data.user.session_id);
      showLoginPopup(false);
      const node = document.getElementById('ext_login');
      if (node) {
        node.innerHTML = res.data.user.session_id;
      }
    } catch (error) {
      console.log(error);
      message.error(error?.response?.data?.detail || t('login.loginFailed'));
    }
    setLoading(false);
  };

  const registerFunc = async () => {
    try {
      const { email, password, name, verification_code, agreement } = form;
      if (!vEmail()) {
        return message.error(t('login.invalidEmail'));
      } else if (!name) {
        return message.error(t('login.nameRequired'));
      } else if (!password) {
        return message.error(t('login.passwordRequired'));
      } else if (!verification_code) {
        return message.error(t('login.verificationCodeRequired'));
      } else if (!agreement) {
        return message.error(t('login.agreementRequired'));
      }
      setLoading(true);
      const res = await register({ email, password, name, verification_code });
      message.success(res.data.message);
      setTabActive(0);
    } catch (error) {
      console.log(error);
      message.error(error?.response?.data?.detail || t('login.signUpFailed'));
    }
    setLoading(false);
  };

  const vEmail = () => {
    return /^[a-zA-Z0-9]+([._-][a-zA-Z0-9]+)*@[a-zA-Z0-9]+([.-][a-zA-Z0-9]+)*\.[a-zA-Z]{2,}$/.test(form.email);
  };

  const googleLogin = async (credentialResponse) => {
    try {
      const res = await googleLoginApi({ token: credentialResponse.credential });
      message.success(res.data.message);
      localStorage.setItem('login_type', 'google');
      localStorage.setItem('session_id', res.data.user.session_id);
      showLoginPopup(false);
    } catch (error) {
      console.log('error', error);
    }
  };

  if (!showLogin) {
    return null;
  }

  return (
    <div className={styles.loginBox} onClick={() => showLoginPopup(false)}>
      <div className={styles.login} onClick={(e) => e.stopPropagation()}>
        <div className={styles.tab}>
          {tabs.map((tab, index) => {
            return (
              <div
                className={tabActive === index ? styles.tabActive : ''}
                onClick={() => setTabActive(index)}
                key={tab.v}
              >
                {tab.l}
              </div>
            );
          })}
        </div>
        <div className={styles.inputs}>
          {tabActive === 1 && (
            <div className={styles.inputBox}>
              <div>
                <img src={userImg} alt="" />
              </div>
              <input
                value={form.name}
                onInput={(e) => changeInput(e.target.value, 'name')}
                type="input"
                placeholder={t('login.name')}
              />
            </div>
          )}
          <div className={styles.inputBox}>
            <div>
              <img src={aiteImg} alt="" />
            </div>
            <input
              value={form.email}
              onInput={(e) => changeInput(e.target.value, 'email')}
              type="input"
              placeholder={t('login.email')}
            />
          </div>
          <div className={styles.inputBox}>
            <div>
              <img src={mimaImg} alt="" />
            </div>
            <input
              value={form.password}
              onInput={(e) => changeInput(e.target.value, 'password')}
              type="password"
              placeholder={t('login.password')}
            />
          </div>
          {tabActive !== 0 && (
            <div className={styles.inputBox}>
              <div>
                <img src={yanzhengmaƒImg} alt="" />
              </div>
              <input
                value={form.verification_code}
                onInput={(e) => changeInput(e.target.value, 'verification_code')}
                type="input"
                placeholder={t('login.verificationCode')}
              />
              <div className={styles.send} onClick={() => send()}>
                {sendText}
              </div>
            </div>
          )}
        </div>
        <Button loading={loading} className={styles.button} onClick={() => submit()}>
          {tabs[tabActive].l}
        </Button>
        <div className={styles.googleLoginButton}>
          <GoogleLogin
            width="350px"
            onSuccess={(credentialResponse) => googleLogin(credentialResponse)}
            onError={() => {
              console.log('Login Failed');
            }}
          />
        </div>
        <label className={styles.agreement}>
          <input
            type="checkbox"
            checked={form.agreement}
            onChange={(e) => changeInput(e.target.checked, 'agreement')}
          />
          <div>
            <a
              className={styles.a}
              target="_blank"
              href="https://www.breezedeus.com/article/p2t-agreement"
              rel="noreferrer"
            >
              {t('login.agreement')} {t('login.serviceAgreement')}
            </a>
          </div>
        </label>
        <div className={styles.forgot} onClick={forgotPassword}>
          {t('login.forgotPassword')}
        </div>
        <img onClick={() => showLoginPopup(false)} className={styles.cancel} src={cancelImg} alt="" />
      </div>
    </div>
  );
};
